import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Text from 'components/Text';
import { getText } from 'helpers/i18n';

import '../ProductPackages/productPackages.styles.scss';

import imgArrowDown from 'images/chevron-down-thin-24.svg';

export default class ProductPartTrigger extends Component {
    onShow() {
        const { toggleDisplay, parentArticle } = this.props;

        toggleDisplay(parentArticle, true);
    }

    onHide() {
        const { toggleDisplay, parentArticle } = this.props;

        toggleDisplay(parentArticle, false);
    }

    render() {
        const { showChildren, parts } = this.props;

        if (!parts) {
            return null;
        }

        if (!showChildren) {
            return (
                <div className="product__toggle-parts">
                    <button className="button button--unstyled" onClick={this.onShow.bind(this)}>
                        <Text textKey="product_parts_show" /> <img src={imgArrowDown} alt={getText('product_parts_show')} />
                    </button>
                </div>
            );
        }

        return (
            <div className="product__toggle-parts product__toggle-parts--up-arrow">
                <button className="button button--unstyled" onClick={this.onHide.bind(this)}>
                    <Text textKey="product_parts_hide" /> <img src={imgArrowDown} alt={getText('product_parts_hide')} />
                </button>
            </div>
        );
    }
}

ProductPartTrigger.propTypes = {
    parentArticle: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    toggleDisplay: PropTypes.func.isRequired,
    showChildren: PropTypes.bool.isRequired,
    parts: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.bool,
    ]).isRequired,
};
